/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Group_AppInputs */

const en_settings_v2_group_app = /** @type {(inputs: Settings_V2_Group_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App`)
};

const es_settings_v2_group_app = /** @type {(inputs: Settings_V2_Group_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicación`)
};

/**
* | output |
* | --- |
* | "App" |
*
* @param {Settings_V2_Group_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_group_app = /** @type {((inputs?: Settings_V2_Group_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Group_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_group_app(inputs)
	return en_settings_v2_group_app(inputs)
});